export default {
  name: 'marking--inputH',
  apiService: 'shoes',
  apiPath: '/admin/input_h',
};